import React from 'react';
import { motion } from 'framer-motion';
import { useReducedMotionPreference } from './ReducedMotionProvider';

export const Reveal = ({
  children,
  className = '',
  delay = 0,
  duration = 0.7,
  yOffset = 24,
  amount = 0.18,
  direction = 'up',
  once = true
}) => {
  const { prefersReducedMotion } = useReducedMotionPreference();

  if (prefersReducedMotion) {
    return <div className={className}>{children}</div>;
  }

  const getInitialPosition = () => {
    switch (direction) {
      case 'down': return { opacity: 0, y: -yOffset };
      case 'left': return { opacity: 0, x: yOffset };
      case 'right': return { opacity: 0, x: -yOffset };
      default: return { opacity: 0, y: yOffset };
    }
  };

  const getFinalPosition = () => {
    switch (direction) {
      case 'left':
      case 'right': return { opacity: 1, x: 0 };
      default: return { opacity: 1, y: 0 };
    }
  };

  return (
    <motion.div
      className={className}
      initial={getInitialPosition()}
      whileInView={getFinalPosition()}
      viewport={{ once, amount }}
      transition={{
        duration,
        delay,
        ease: [0.16, 1, 0.3, 1]
      }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
